function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4064 0H6.59347C6.23848 0 5.95068 0.323471 5.95068 0.722463V5.05724C5.95068 5.45623 6.23848 5.7797 6.59347 5.7797H17.4064C17.7614 5.7797 18.0492 5.45623 18.0492 5.05724V0.722463C18.0492 0.323423 17.7614 0 17.4064 0Z",
  fill: "#108647"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0H6.59347C6.23848 0 5.95068 0.323471 5.95068 0.722463V5.05724C5.95068 5.45623 6.23848 5.7797 6.59347 5.7797H12V0Z",
  fill: "#18CC6C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8781 1.87965L17.6957 0.0773014C17.537 -0.0125248 17.3523 -0.0245658 17.1854 0.0440681C17.0185 0.11275 16.8844 0.256039 16.8149 0.439833L12 13.1705L7.18513 0.439833C7.11562 0.256039 6.98145 0.11275 6.81463 0.0440681C6.64767 -0.024614 6.46298 -0.0126211 6.30434 0.0773014L3.12198 1.87961C2.1407 2.43542 1.72949 3.75083 2.18587 4.87421L6.70497 16H10.2847H17.295L21.8141 4.87426C22.2705 3.75083 21.8593 2.43542 20.8781 1.87965Z",
  fill: "#18CC6C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 13.1705L7.18513 0.439833C7.11562 0.256039 6.98145 0.11275 6.81463 0.0440681C6.64767 -0.024614 6.46298 -0.0126211 6.30434 0.0773014L3.12198 1.87961C2.1407 2.43542 1.72949 3.75083 2.18587 4.87421L6.70497 16H12V13.1705Z",
  fill: "#71EBAA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12C8.69158 12 6 14.6916 6 18C6 21.3084 8.69158 24 12 24C15.3084 24 18 21.3084 18 18C18 14.6917 15.3084 12 12 12Z",
  fill: "#FFC94D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5106 15.8857L12.7328 16.5967C12.8046 16.8267 13.0107 16.9824 13.2433 16.9824H13.9622C14.4822 16.9824 14.6984 17.6744 14.2777 17.9922L13.6961 18.4316C13.5079 18.5738 13.4292 18.8258 13.5011 19.0558L13.7232 19.7667C13.8839 20.281 13.3179 20.7087 12.8971 20.3909L12.3155 19.9515C12.1274 19.8093 11.8726 19.8093 11.6845 19.9515L11.1029 20.3909C10.6821 20.7087 10.1161 20.2811 10.2768 19.7667L10.4989 19.0558C10.5708 18.8258 10.4921 18.5738 10.3039 18.4316L9.72232 17.9922C9.3016 17.6744 9.51782 16.9824 10.0378 16.9824H10.7567C10.9893 16.9824 11.1954 16.8267 11.2672 16.5967L11.4894 15.8857C11.6502 15.3714 12.3499 15.3714 12.5106 15.8857Z",
  fill: "#FFFDF2"
});

var SvgBestPlayer = function SvgBestPlayer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBestPlayer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bestPlayer.c0cf0264.svg";
export { ForwardRef as ReactComponent };